import { FC } from "react";
import { IMiniScentCartridge } from "../../types";
import SectionCard from "./SectionCard";
import { InvertColors } from "@mui/icons-material";
import {
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";

interface CartridgesSectionProps {
  cartridges?: IMiniScentCartridge[];
  totalCartridges: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => void;
  onRowsPerPageChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  isLoading: boolean;
  translate: (key: string) => string;
}

const CartridgesSection: FC<CartridgesSectionProps> = ({
  cartridges,
  totalCartridges,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  isLoading,
  translate,
}) => (
  <SectionCard
    title="Cartuchos Configurados"
    icon={<InvertColors />}
    isLoading={isLoading}
  >
    {cartridges && cartridges.length > 0 ? (
      <>
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Serial do Cartucho</TableCell>
                <TableCell>Serial do Dispositivo</TableCell>
                <TableCell align="center">Disparos Configurados</TableCell>
                <TableCell align="center">Disparos Restantes</TableCell>
                <TableCell>Data de Criação</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cartridges.map(cartridge => (
                <TableRow
                  key={cartridge.miniscentCartridgeId}
                  hover
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell>{cartridge.cartridgeSerialNumber}</TableCell>
                  <TableCell>{cartridge.deviceSerialNumber}</TableCell>
                  <TableCell align="center">
                    {cartridge.totalConfiguredShots}
                  </TableCell>
                  <TableCell align="center">
                    <Chip
                      label={cartridge.totalRemainingShots}
                      color={
                        cartridge.totalRemainingShots > 50
                          ? "success"
                          : cartridge.totalRemainingShots > 10
                          ? "warning"
                          : "error"
                      }
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    {moment(cartridge.createdAt).format("DD/MM/YYYY HH:mm")}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={totalCartridges}
          page={page}
          onPageChange={onPageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={onRowsPerPageChange}
          rowsPerPageOptions={[5, 10, 25]}
          labelRowsPerPage="Itens por página:"
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count}`
          }
        />
      </>
    ) : (
      <Typography color="text.secondary" align="center">
        Nenhum cartucho encontrado
      </Typography>
    )}
  </SectionCard>
);

export default CartridgesSection;
